import React from 'react';
import { Box, Typography, Link, IconButton } from '@mui/material';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import { connect } from 'react-redux';
import { LandingEmailSentContent } from '@integraciones_doc24/wehealthy-api/types/landing';

interface CheckEmailProps {
  content?: LandingEmailSentContent;
  email?: string;
  formValues: { [k: string]: any };
}

const CheckEmail: React.FC<CheckEmailProps> = ({ content, email, formValues }) => {
  if (!content) return null;

  return (
    <Box
      sx={{
        backgroundColor: '#fff',
        p: 5,
        borderRadius: 3,
        maxWidth: 500,
        mx: 'auto',
        mt: 6,
        textAlign: 'center',
        boxShadow: '0px 2px 8px rgba(0,0,0,0.1)',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: 56,
          height: 56,
          backgroundColor: '#f5f5f5',
          borderRadius: '50%',
          mx: 'auto',
          mb: 2,
        }}
      >
        <IconButton disableRipple>
          <MailOutlineIcon sx={{ fontSize: 32, color: '#4b4b4b' }} />
        </IconButton>
      </Box>

      <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 1 }}>
        {content.title}
      </Typography>

      <Typography variant="body1" sx={{ color: 'text.secondary', mb: 3 }}>
        {content.subtitle.replace('{{email}}', formValues.email.value)}
      </Typography>

      <Typography variant="body2" sx={{ color: 'text.secondary' }}>
        {content.helpText}{' '}
        <Link href="#" underline="always" sx={{ fontWeight: 500 }}>
          {content.resendLinkText}
        </Link>
      </Typography>
    </Box>
  );
};

const mapStateToProps = (state: any) => ({
  formValues: state.configReducer.formValues, // 👈 traemos desde redux
});

export default connect(mapStateToProps)(CheckEmail);